import {
  CONTACT_ADD,
  CONTACT_GET_ALL,
  CONTACT_SEARCH,
  CONTACT_GET_BY_ID,
  CONTACT_UPDATE,
  CONTACT_DELETE,
  CONTACT_MULTIPLE_DELETE,
  CONTACT_IMPORT,
  CONTACT_EXPORT,
  CONTACT_CHAT_LIST,
  CAMPAIGN_SEND,
  CAMPAIGN_GET_ALL,
  CAMPAIGN_REPORT,
  CAMPAIGN_SINGLE_SEND,
  CAMPAIGN_LOGS,
  CAMPAIGN_DASHBOARD_SUMMARY,
  CAMPAIGN_REPORT_CONTACTS,
  GROUP_CREATE,
  GROUP_GET_ALL,
  GROUP_DELETE,
  GROUP_CONTACTS,
  GROUP_GET_BY_ID,
  GROUP_ADD_CONTACT,
  TEMPLATE_GET_ALL,
  TEMPLATE_CREATE,
  MESSAGE_SEND,
  MESSAGE_GET_CHAT,
  MEDIA_UPLOAD,
  CREDENTIALS_GET,
} from '../actions/Chatbox.action';

const initialState = {
  addContact: '',
  getAllContacts: '',
  getContactById: '',
  updateContact: '',
  deleteContact: '',
  multipleDeleteContact: '',
  importContacts: '',
  exportContacts: '',
  chatContacts: '',

  sendCampaign: '',
  getAllCampaigns: '',
  campaignReport: '',
  sendSingleMessage: '',
  campaignLogs: '',
  dashboardSummary: '',
  campaignReportContacts: '',
  createGroup: '',
  getAllGroups: '',
  deleteGroup: '',
  getContactsOfGroup: '',
  getGroupById: '',
  addContactToGroup: '',
  getTemplates: '',
  createTemplate: '',

  sendChatMessage: '',
  getChatMessages: '',
  uploadMedia: '',
  getCredentials: '',
};

const chatboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTACT_ADD:
      return { ...state, addContact: action.payload };
    case CONTACT_GET_ALL:
      return { ...state, getAllContacts: action.payload };
    case CONTACT_SEARCH:
      return { ...state, getAllContacts: action.payload };
    case CONTACT_GET_BY_ID:
      return { ...state, getContactById: action.payload };
    case CONTACT_UPDATE:
      return { ...state, updateContact: action.payload };
    case CONTACT_DELETE:
      return { ...state, deleteContact: action.payload };
    case CONTACT_MULTIPLE_DELETE:
      return { ...state, multipleDeleteContact: action.payload };
    case CONTACT_IMPORT:
      return { ...state, importContacts: action.payload };
    case CONTACT_EXPORT:
      return { ...state, exportContacts: action.payload };
    case CONTACT_CHAT_LIST:
      return { ...state, chatContacts: action.payload };

    case CAMPAIGN_SEND:
      return { ...state, sendCampaign: action.payload };
    case CAMPAIGN_GET_ALL:
      return { ...state, getAllCampaigns: action.payload };
    case CAMPAIGN_REPORT:
      return { ...state, campaignReport: action.payload };
    case CAMPAIGN_SINGLE_SEND:
      return { ...state, sendSingleMessage: action.payload };
    case CAMPAIGN_LOGS:
      return { ...state, campaignLogs: action.payload };
    case CAMPAIGN_DASHBOARD_SUMMARY:
      return { ...state, dashboardSummary: action.payload };
    case CAMPAIGN_REPORT_CONTACTS:
      return { ...state, campaignReportContacts: action.payload };

    case GROUP_CREATE:
      return { ...state, createGroup: action.payload };
    case GROUP_GET_ALL:
      return { ...state, getAllGroups: action.payload };
    case GROUP_DELETE:
      return { ...state, deleteGroup: action.payload };
    case GROUP_CONTACTS:
      return { ...state, getContactsOfGroup: action.payload };
    case GROUP_GET_BY_ID:
      return { ...state, getGroupById: action.payload };
    case GROUP_ADD_CONTACT:
      return { ...state, addContactToGroup: action.payload };

    case TEMPLATE_GET_ALL:
      return { ...state, getTemplates: action.payload };
    case TEMPLATE_CREATE:
      return { ...state, createTemplate: action.payload };

    case MESSAGE_SEND:
      return { ...state, sendChatMessage: action.payload };
    case MESSAGE_GET_CHAT:
      return { ...state, getChatMessages: action.payload };

    case MEDIA_UPLOAD:
      return { ...state, uploadMedia: action.payload };

    case CREDENTIALS_GET:
      return { ...state, getCredentials: action.payload };

    default:
      return state;
  }
};

export default chatboxReducer;
